module.exports = __webpack_public_path__ + "static/media/kids_07.78170e3d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/kids/JPEG/kids_07.jpg
// module id = 5863
// module chunks = 0